import { render, staticRenderFns } from "./terveyskeskuskoulutusjaksot-el.vue?vue&type=template&id=0a00aba5&scoped=true&"
import script from "./terveyskeskuskoulutusjaksot-el.vue?vue&type=script&lang=ts&"
export * from "./terveyskeskuskoulutusjaksot-el.vue?vue&type=script&lang=ts&"
import style0 from "./terveyskeskuskoulutusjaksot-el.vue?vue&type=style&index=0&id=0a00aba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a00aba5",
  null
  
)

export default component.exports